module.exports = __webpack_public_path__ + "img/opening_box_bg.f5c29c51.png";